"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _56IW3LDCcjs = require('../__chunks/56IW3LDC.cjs');


var _TVPBHOOYcjs = require('../__chunks/TVPBHOOY.cjs');
require('../__chunks/MLKK6UGO.cjs');
require('../__chunks/MMSR5JSJ.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/radio/radio-provider.tsx
var _jsxruntime = require('react/jsx-runtime');
function RadioProvider(props = {}) {
  const store = _56IW3LDCcjs.useRadioStore.call(void 0, props);
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _TVPBHOOYcjs.RadioContextProvider, { value: store, children: props.children });
}


exports.RadioProvider = RadioProvider;
